import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { GetUserStatsResp } from '../types/user-stats'

export const getUserStats = (userId: number) => {
  return api.get<GetUserStatsResp>(`/users/${userId}/stats`, {
    headers: moneyObjectHeader,
  })
}
